class BuyNowButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.buyNow.bind(this));
    this.closest('product-form').setAttribute('buy-now-button', 'true');
  }

  buyNow(event) {
    if(this.getAttribute('disabled') === 'true') {
        event.stopPropagation();
        event.preventDefault();
        return;
    }
    event.preventDefault();

    const formId = this.dataset.productFormId;
    const form = document.getElementById(formId);
    const variantId = form.querySelector('[name="id"]').value;
    const quantity = form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1;

    // Check for upsells using data attributes (same as regular add to cart)
    const productForm = this.closest('product-form');
    const productInfo = productForm ? productForm.closest('product-info') : null;
    const upsellRadios = productInfo ?
      productInfo.querySelectorAll('product-upsell input[type="radio"]:checked[data-upsell-variant-id]') :
      [];
    const upsellVariantIds = Array.from(upsellRadios)
      .map(radio => radio.dataset.upsellVariantId)
      .filter(id => id);

    // Build cart items array: main product + upsells
    const cartItems = [

      ...upsellVariantIds.map(variantId => ({
        id: variantId,
        quantity: quantity
      })),
      {
        id: variantId,
        quantity: quantity
      },
    ];

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: cartItems })
      });
    })
    .then(response => response.json())
    .then(cart => {
      if (cart.status) {
        // handle error
        console.error(cart.description);
        return;
      }
      window.location.href = '/checkout';
    })
    .catch(error => console.error('Error:', error));
  }
}

customElements.define('buy-now-button', BuyNowButton);
